import { StompService } from '@stomp/ng2-stompjs';
var WebsocketService = /** @class */ (function () {
    function WebsocketService(stompService) {
        this.stompService = stompService;
    }
    WebsocketService.prototype.listen = function (UUID) {
        return this.stompService.subscribe('/topic/action/' + UUID);
    };
    return WebsocketService;
}());
export { WebsocketService };
